import { Space, Tag, Typography } from "antd"
import { ProjectType, projectTypeName } from "../../../common/constants"
import VSpace from "../../common/VSpace"
import { ReportFilterViewModel } from "../datacenterModel"
import ReportFilterDateDetails from "../ReportFilterDateDetails"

const { Text } = Typography

type Props = {
  filterItem: ReportFilterViewModel
}

const VisitNotesReportFilterDetails = ({ filterItem }: Props) => {
  return <VSpace>
    <ReportFilterDateDetails filterItem={filterItem} />
    <Space>
      {'searchTerm' in filterItem.filters && filterItem.filters.searchTerm && <Text type='secondary'>Search Term: {filterItem.filters.searchTerm}</Text>}
    </Space>
    <Space>
      {'jobTypes' in filterItem.filters && filterItem.filters.jobTypes.map(jobType => <Tag key={jobType}>{projectTypeName(jobType as ProjectType)}</Tag>)}
    </Space>
  </VSpace>
}

export default VisitNotesReportFilterDetails